<template>
  <div class="Card">
    <h3 class="Card__title">{{ title }}</h3>
    <p class="Card__content">{{ content }}</p>
  </div>
</template>
<script>
export default {
  name: 'Card',
  props: {
    title: String,
    content: String
  }
}
</script>

<style lang="scss">
.Card {
  width: 100%;
  max-width: 565px;
  padding: 42px 30px;
  background: #FFFFFF;
  border: 1px solid #F2F2F2;
  box-sizing: border-box;
  box-shadow: 0 15px 30px -10px rgba(21, 17, 71, 0.09);
  border-radius: 24px;
  color: $color;
  margin-bottom: 30px;
  &__title {
    font-weight: bold;
    font-size: 36px;
    line-height: 110%;
    margin-bottom: 24px;
    @media screen and (max-width: 775px) {
      font-size: 24px;
    }
  }
  &__content {
    font-size: 18px;
    line-height: 150%;
  }
}
</style>
